import React, { Component, useEffect, useRef } from 'react';
import { Widget } from "react-chat-widget";
import "react-chat-widget/lib/styles.css";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Image } from 'react-bootstrap';
/* import { Button } from 'primereact/button'; */
import ForumOutlinedIcon from '@material-ui/icons/ForumOutlined';
import { LoadCanvasTemplate } from 'react-simple-captcha';
/* import { InputText } from 'primereact/inputtext'; */
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import TypewriterMarkdown from './typeWriter';

const typedMessages = new Set();

// util para crear una key si no te pasan messageId
function makeKeyFromProps(props) {
    if (props.messageId) return String(props.messageId);
    // fallback: usa texto + origen (corta a 200 chars para evitar keys gigantes)
    const text = (props.text || '').slice(0, 200);
    return `${props.from || 'unknown'}|${text}`;
}

const AccessibleChatWidget = ({
    company,
    idConversartion,
    startConversation,
    handleNewUserMessage,
}) => {
    const containerRef = useRef(null);
    const labelId = "chat-message-label";

    useEffect(() => {
        if (typeof document === "undefined") return;

        // Insertar label sr-only si no existe
        if (containerRef.current && !containerRef.current.querySelector(`#${labelId}`)) {
            const labelEl = document.createElement("label");
            labelEl.id = labelId;
            labelEl.className = "sr-only";
            labelEl.textContent = "Escribe tu mensaje en el chat";
            containerRef.current.insertBefore(labelEl, containerRef.current.firstChild);
        }

        // Función que aplica accesibilidad
        const applyAccessibility = () => {
            // Input de texto
            const input = document.querySelector(".rcw-new-message");
            if (input) {
                input.setAttribute("aria-labelledby", labelId);
                input.setAttribute("title", "Campo de texto para escribir un mensaje en el chat");
                if (!input.hasAttribute("tabindex")) {
                    input.setAttribute("tabindex", "0");
                }
            }

            // Botón enviar
            const sendBtn = document.querySelector(".rcw-send");
            if (sendBtn) {
                sendBtn.setAttribute("aria-label", "Enviar mensaje");
                sendBtn.setAttribute("title", "Enviar mensaje");
            }

            //imagen de header logo del cliente
            const logoBotForm = document.querySelector(".chat-image-header");
            if (logoBotForm) {
                // Si quieres que sea descriptivo
                logoBotForm.setAttribute("alt", "Logo cliente asistente virtual");
                logoBotForm.setAttribute("title", "Logo cliente asistente virtual");
            }

            //imagen de header logo del cliente
            const avatarForm = document.querySelector(".rcw-avatar");
            if (avatarForm) {
                // Si quieres que sea descriptivo
                avatarForm.setAttribute("alt", "Avatar del asistente virtual");
                avatarForm.setAttribute("title", "Avatar del asistente virtual");
            }
            // Ícono del botón enviar
            const sendIcon = document.querySelector(".rcw-send-icon");
            if (sendIcon) {
                sendIcon.setAttribute("alt", "");
                sendIcon.removeAttribute("title");
            }

            // Botón launcher (abrir/cerrar chat)
            const launcher = document.querySelector(".rcw-open-launcher");
            if (launcher) {
                launcher.setAttribute("aria-label", "Abrir chat - asistente virtual");
                launcher.setAttribute("title", "Abrir chat - asistente virtual");
                launcher.setAttribute("role", "button");
                launcher.setAttribute("tabindex", "0");

                // Mejorar navegación con teclado
                if (!launcher.__accessibleKeyHandlerInstalled) {
                    const keyHandler = (e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            launcher.click();
                        }
                    };
                    launcher.addEventListener("keydown", keyHandler);
                    launcher.__accessibleKeyHandlerInstalled = true;
                }
            }
        };

        // Ejecutar una vez y observar cambios en DOM
        applyAccessibility();
        const observer = new MutationObserver(() => applyAccessibility());
        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, []);

    return (
        <div ref={containerRef} className="chat-widget-wrapper">
            <style>{`
        .sr-only {
          position: absolute !important;
          width: 1px !important;
          height: 1px !important;
          padding: 0 !important;
          margin: -1px !important;
          overflow: hidden !important;
          clip: rect(0, 0, 0, 0) !important;
          white-space: nowrap !important;
          border: 0 !important;
        }
      `}</style>

            <Widget
                title={company.nombre}
                subtitle=""
                className="chat-widget-container"
                senderPlaceHolder="¿En qué te puedo ayudar?"
                handleNewUserMessage={!idConversartion ? startConversation : handleNewUserMessage}
                profileAvatar={company.avatar}
                titleAvatar={company.logoNombre}
                toggleInputDisabled={false}
                toggleWidget={true}
            />
        </div>
    );
};

export default AccessibleChatWidget;

// const AccessibleChatWidget = ({ company, idConversartion, startConversation, handleNewUserMessage }) => {
//     useEffect(() => {
//         // Forzar accesibilidad en launcher (botón de abrir/cerrar chat)
//         // const logoBotForm = document.querySelector(".chat-image-header");
//         // if (logoBotForm) {
//         //     logoBotForm.setAttribute("alt", "Logo cliente chatbot");
//         //     logoBotForm.setAttribute("title", "Logo cliente chatbot");
//         // }

//         const buttonClosedBot = document.querySelector(".rcw-open-launcher");
//         if (buttonClosedBot) {

//             buttonClosedBot.setAttribute("alt", "Avatar del asistente virtual");
//             buttonClosedBot.setAttribute("title", "Avatar del asistente virtual"); // visible al pasar mouse
//         }

//         const cajaNewMsg = document.querySelector(".rcw-new-message");
//         if (cajaNewMsg) {

//             cajaNewMsg.setAttribute("aria-label", "Campo de texto para escribir un mensaje en el chat");
//             cajaNewMsg.setAttribute("title", "Campo de texto para escribir un mensaje en el chat"); // visible al pasar mouse
//         }

//     }, []);

//     return (
//         <Widget
//             title={company.nombre}
//             subtitle=""
//             className="chat-widget-container"
//             senderPlaceHolder="¿En qué te puedo ayudar?"
//             inputAttributes={{
//                 "aria-label": "Campo de texto para escribir un mensaje en el chat",
//                 "title": "Campo de texto para escribir un mensaje en el chat"
//             }}
//             handleNewUserMessage={!idConversartion ? startConversation : handleNewUserMessage}
//             profileAvatar={company.avatar}
//             titleAvatar={company.logoNombre}
//             toggleInputDisabled={false}
//             toggleWidget={true}
//         // launcherCloseImg="https://firebasestorage.googleapis.com/v0/b/chat-asesores-prueba.appspot.com/o/alcaldiaBogota%2Flogo_chatico.png?alt=media&token=d3e50bea-2ab0-4ea1-a253-c4ad880169eb"
//         // launcherOpenImg="https://firebasestorage.googleapis.com/v0/b/chat-asesores-prueba.appspot.com/o/alcaldiaBogota%2Flogo_chatico.png?alt=media&token=d3e50bea-2ab0-4ea1-a253-c4ad880169eb"
//         />
//     );
// };


export class RichText extends Component {
    state = {
        mostrarTypewriter: false
    };

    componentDidMount() {
        const { nuevoMsge } = this.props;
        const key = makeKeyFromProps(this.props);
        this._messageKey = key; // por si quieres usarlo después

        // Si es un "nuevo mensaje" y aún no lo hemos tipeado -> activar y marcarlo
        if (nuevoMsge && !typedMessages.has(key)) {
            typedMessages.add(key);
            this.setState({ mostrarTypewriter: true });
        }
    }

    componentDidUpdate() {
        console.log("actualizando")
    }

    render() {
        const { text, from, typeWriterWeb, nuevoMsge } = this.props;
        const { mostrarTypewriter } = this.state;
        let richtext = text ? text.replaceAll(/\*/ig, '**').replaceAll(/\n+/ig, '\n\n') : '';

        return (
            <div className='richtext-message typewriter-container'>
                {typeWriterWeb && mostrarTypewriter ?

                    <TypewriterMarkdown
                        richtext={richtext} speed={20}
                    />
                    : <ReactMarkdown remarkPlugins={[remarkGfm]} linkTarget="_blank" children={richtext} />
                }

            </div>
        );
    }
}

export class CustomSpinner extends Component {
    render() {
        const { id, text, type, className, spinnerClassName, textClassName, color } = this.props;

        return (
            <div className={`modal-container-${className}`}>
                <div id={id} className={className}>
                    {
                        type === 'linear' ? <LinearProgress className={spinnerClassName} color={color} /> :
                            <CircularProgress className={spinnerClassName} color={color} />
                    }
                    {text && <p className={textClassName}> {text} </p>}
                </div>
            </div>
        );
    }
}

export class CustomCaptcha extends Component {
    render() {
        const { subtitle, logo, reloadText, placeholder, renderThis, svgIconX } = this.props;

        return (
            <div className="captcha-container">
                <div className='form-title'>
                    <Image style={{ maxWidth: "51%" }} className='image-title' src={logo}></Image>
                    <ForumOutlinedIcon className="icon-title" />
                </div>
                <p className="form-sub-title">
                    {subtitle}
                </p>

                <div className="captchaForm">
                    <div className="flex align-items-center justify-content-center ">
                        <LoadCanvasTemplate
                            reloadText={reloadText} />
                    </div>
                    <div className="flex align-items-center justify-content-center mt-2">
                        {/* <InputText style={{ "width": "13rem" }} placeholder={placeholder} value={renderThis.state.valueCaptcha} onInput={(e) => renderThis.setState({ valueCaptcha: e.target.value })} /> */}
                        <TextField sx={{ "width": "13rem" }} id="outlined-basic" label={placeholder} variant="outlined" value={renderThis.state.valueCaptcha} onInput={(e) => renderThis.setState({ valueCaptcha: e.target.value })} />
                    </div>
                    {renderThis.state.errorCaptchaInvalido ?
                        <div className="flex align-items-center justify-content-center">
                            <p style={{ "color": "red", "paddingTop": "0px" }} className="form-sub-title" >Caracteres incorrectos, intente de nuevo.</p>
                        </div>
                        : false}
                    <div className="flex align-items-center justify-content-center mt-3">
                        {/* <Button className="p-button-info" label="Enviar" onClick={() => renderThis.doSubmit(renderThis.state.valueCaptcha)}></Button> */}
                        <Button color="secondary" variant="contained" onClick={() => renderThis.doSubmit(renderThis.state.valueCaptcha)}>Enviar</Button>
                    </div>
                </div>
                <React.Fragment>
                    <div className="fake-field"></div>
                    <div className="fake-button close">
                        <button className="rcw-close-button rcw-fake-close-button">
                            <img src={svgIconX} className="rcw-close" alt="close" />
                        </button>
                    </div>
                </React.Fragment>
            </div>
        );
    }
}

